import { Divider, Grid, InputAdornment, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, InputAuto, InputDate } from "../../controls";
import { Model, UseForm } from "../../hooks";
import { Alert, Form } from "../../layout";
import { API, actions, endpoints } from "../../api/api";
import { AppContext } from "../../App";
import { RmvEmptyProp, ToFormData } from "../../hooks/Method";
import moment from "moment";
import { useTranslation } from "react-i18next";

const AddEditInv = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { InvoiceMdl } = Model();
  const { values, setValues, errors, setErrors, handleInpChg, handleInpDate } =
    UseForm(InvoiceMdl);
  const { branch, authUser } = useContext(AppContext);
  const [members, setMembers] = useState([]);
  const [subsPlans, setSubsPlans] = useState([]);
  const [subsTypes, setSubsTypes] = useState([]);
  const [invHaveMsg, setInvHaveMsg] = useState();
  const [selTypePlans, setSelTypePlans] = useState([]);
  const [memberInvs, setMemberInvs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (branch && branch.id) {
      API(endpoints.Member + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setMembers([
            ...res.result.map((j) => ({
              ...j,
              label: j.firstName + " " + j.lastName,
            })),
          ])
      );
      API(endpoints.SubsType + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setSubsTypes([
            ...res.result.map((j) => ({ id: j.id, label: j.name })),
          ])
      );
      API(endpoints.SubsPlan + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setSubsPlans([...res.result.map((j) => ({ ...j, label: j.name }))])
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  useEffect(() => {
    setSelTypePlans([
      ...subsPlans.filter((j) => j.subsTypeId === values.subsTypeId),
    ]);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.subsTypeId, subsPlans]);

  useEffect(() => {
    if (values && values.memberId)
      API(endpoints.Invoice + actions.GetAllByMember).getById(
        values.memberId,
        (res) => {
          if (res) {
            setMemberInvs([
              ...res.result.filter((j) => new Date() < new Date(j.endDate)),
            ]);
          }
        }
      );

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.memberId]);

  useEffect(() => {
    if (memberInvs && memberInvs.length) {
      if (memberInvs.some((j) => j.subsTypeId === values.subsTypeId)) {
        var lastInv = memberInvs
          .filter((j) => j.subsTypeId === values.subsTypeId)
          .slice(-1)
          .pop();
        lastInv &&
          setValues((x) => ({
            ...x,
            startDate: moment(lastInv.endDate, "MM/DD/YYYY")
              .add(1, "days")
              .format("MM/DD/YYYY"),
          }));

        setInvHaveMsg(
          `${
            t("invHaveMsg1") +
            " " +
            memberInvs.length +
            +" " +
            t("invHaveMsg1") +
            " " +
            " $" +
            memberInvs.slice(-1).pop().title
          }`
        );
      } else {
        setValues((x) => ({
          ...x,
          startDate: "",
        }));
        setInvHaveMsg();
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberInvs, values.duration]);

  useEffect(() => {
    if (values.subsPlanId) {
      var plan = subsPlans.find((j) => j.id === values.subsPlanId);
      plan &&
        setValues((x) => ({
          ...x,
          title: plan.name,
          amount: plan.amt,
          netPay: plan.amt,
          freeFreezeCount: plan.freezeCount,
          duration: plan.duration,
        }));
    } else
      setValues((x) => ({
        ...x,
        title: "",
        amount: "",
        netPay: "",
        freeFreezeCount: "",
        duration: "",
        dueDate: "",
        startDate: "",
        endDate: "",
      }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.subsPlanId]);

  useEffect(() => {
    setValues((x) => ({
      ...x,
      netPay: values.discount
        ? (
            parseFloat(values.amount) -
            parseFloat(values.amount) * (parseFloat(values.discount) / 100)
          ).toFixed(2)
        : values.amount,
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.discount]);

  useEffect(() => {
    if (values.startDate) {
      setValues((x) => ({
        ...x,
        endDate: new Date(
          moment(values.startDate, "DD/MM/YYYY").add(values.duration, "days")
        ).toLocaleDateString(),
      }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.startDate, values.duration]);

  const handleSubType = (e) => {
    values.subsPlanId = "";
    handleInpChg(e);
  };

  const validateForm = () => {
    let temp = {};
    temp.memberId = values.memberId !== "" ? "" : t("ValMember");
    temp.typeId = values.typeId !== "" ? "" : t("ValSubsType");
    temp.planId = values.planId !== "" ? "" : t("ValSubsPlan");
    temp.dueDate = values.dueDate !== "" ? "" : t("ValDueDate");
    temp.startDate = values.startDate !== "" ? "" : t("ValStartDate");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: t("InvSuccessTitle"),
            onClick: () => navigate("/invoices"),
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        values.today = new Date().toLocaleDateString();
        API(endpoints.Invoice + actions.Post).post(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else
        API(endpoints.Invoice + actions.Put).put(
          ToFormData(RmvEmptyProp(values)),
          onComplete
        );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                variant="h5"
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {t("CreateInvoice")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {t("Submit")}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-15 pr-15 pb-15 mt-30">
            {invHaveMsg && (
              <div className="mb-20 ml-10 warning-color fs-14">
                <span className="fw-6">{t("Note")}:</span>
                <span>&nbsp;{invHaveMsg}</span>
              </div>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={2.5}>
                <InputAuto
                  label={t("Member")}
                  name="memberId"
                  required={true}
                  value={values.memberId}
                  error={errors.memberId}
                  onChange={handleInpChg}
                  options={members}
                />
              </Grid>
              <Grid item xs={12} md={2.5}>
                <InputAuto
                  label={t("SubscriptionType")}
                  name="subsTypeId"
                  required={true}
                  value={values.subsTypeId}
                  error={errors.subsTypeId}
                  onChange={handleSubType}
                  options={subsTypes}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <InputAuto
                  label={t("SubscriptionPlan")}
                  name="subsPlanId"
                  required={true}
                  value={values.subsPlanId}
                  error={errors.subsPlanId}
                  onChange={handleInpChg}
                  disabled={selTypePlans.length ? false : true}
                  options={selTypePlans}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label={t("InvoiceTitle")}
                  name="title"
                  value={values.title}
                  error={errors.title}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label={t("Amount")}
                  name="amount"
                  value={values.amount}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label={t("Discount")}
                  name="discount"
                  value={values.discount}
                  error={errors.discount}
                  type="number"
                  placeholder="0.00%"
                  disabled={values.amount ? false : true}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label={t("NetPay")}
                  name="netPay"
                  value={values.netPay}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label={t("FreeFreezeCount")}
                  name="freeFreezeCount"
                  value={values.freeFreezeCount}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label={t("Duration")}
                  name="duration"
                  value={values.duration}
                  disabled
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {t("Days")}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <InputDate
                  label={t("DueDate")}
                  name="dueDate"
                  value={new Date(values.dueDate)}
                  error={errors.dueDate}
                  required={true}
                  disabled={values.subsPlanId ? false : true}
                  minDate={new Date()}
                  onChange={(date) =>
                    handleInpDate(
                      "dueDate",
                      new Date(date).toLocaleDateString()
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <InputDate
                  label={t("StartDate")}
                  name="startDate"
                  value={new Date(values.startDate)}
                  error={errors.startDate}
                  required={true}
                  disabled={values.subsPlanId && !invHaveMsg ? false : true}
                  minDate={new Date()}
                  onChange={(date) =>
                    handleInpDate(
                      "startDate",
                      new Date(date).toLocaleDateString()
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Input
                  label={t("EndDate")}
                  name="endDate"
                  value={values.endDate}
                  error={errors.endDate}
                  disabled
                  onChange={handleInpChg}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditInv;
